import { Link } from 'react-router-dom';
import { ReactComponent as PlusIcon } from 'images/icons/Plus.svg';
import { observer } from 'mobx-react-lite';

type Props = {
  route: string;
  buttonTitle: string;
  customClasses?: string;
};

export const HeaderCreateButton = observer(({ route, buttonTitle, customClasses = 'primary' }: Props) => {
  return (
    <div className='admin-list-header-button'>
      <Link to={`/Admin/${route}`} className={`styled-button link-button ${customClasses}`}>
        <PlusIcon />
        <span>{buttonTitle}</span>
      </Link>
    </div>
  );
});

export default HeaderCreateButton;
